import Pagination from "components/base/Pagination";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import { HeaderStyles, ContainerStyles, HeadingStyles, TextStyles } from "styles/style";

export default function BaseView({
  title = null,
  description = null,
  listCount = 0,
  children,
  search,
  onSearchChange,
  page,
  onPageChange,
  pageSize = 15
}) {
  return (
    <AnimationRevealPage>
      <HeaderStyles.ContentStyledHeader />
      <ContainerStyles.Container>
        <ContainerStyles.ContentWithPaddingXl>
          <HeadingStyles.HeadingRow>
            <HeadingStyles.Heading>
              <TextStyles.HighlightedText>{title}</TextStyles.HighlightedText>
            </HeadingStyles.Heading>
          </HeadingStyles.HeadingRow>
          {description && <TextStyles.Description>{description}</TextStyles.Description>}

          {/* 🔍 Search */}
          <ContainerStyles.SearchContainer style={{ margin: "20px" }}>
            <TextStyles.SearchInput
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search..."
              style={{
                fontSize: "18px",
                border: "2px solid pink",
                padding: "8px",
                width: "100%",
              }}
            />
          </ContainerStyles.SearchContainer>

          {/* Render children (list content) */}
          {children}

          {/* 🔄 Pagination */}
          <ContainerStyles.PaginationContainer>
            {listCount > pageSize && (
              <Pagination
                totalLength={listCount}
                pageSize={pageSize}
                page={page}
                onChange={(_, newPage) => onPageChange(newPage)}
              />
            )}
          </ContainerStyles.PaginationContainer>
        </ContainerStyles.ContentWithPaddingXl>
      </ContainerStyles.Container>
    </AnimationRevealPage>
  );
}
